module.exports = __webpack_public_path__ + "static/media/1002222.dbe9dacb.png";